import { Country } from '../country';

export class Tax {
    constructor(
        public id?: number,
        public code?: string,
        public rate?: number,
        public country?: Country,
        public descripttion?: string,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/tax/tax.model.ts